import { cva, type VariantProps } from 'class-variance-authority';

export { default as Title } from './Title.vue';

export const titleVariants = cva('font-semibold font-title', {
    variants: {
        size: {
            default: 'text-3xl/tight lg:text-title',
            sm: 'text-2xl md:text-subtitle',
            lg: 'text-4.5xl/tight md:text-5xl/tight lg:text-6xl/tight'
        }
    },
    defaultVariants: {
        size: 'default'
    }
})

export type TitleVariants = VariantProps<typeof titleVariants>